import Home from "@/modules/home/pages/Home.vue";
import VerificationCancelled from "@/modules/home/pages/VerificationCancelled.vue";

export default [
  {
    path: "/",
    name: "home",
    component: Home,
  },
  {
    path: "/verification-cancelled",
    name: "verification-cancelled",
    component: VerificationCancelled,
  },
];
